import React from 'react';
import { FeaturesContainer, type FeaturesContainerRef } from '../Features';
import FeaturesSection from '../FeaturesSection';
import type { PhaseOrderEntry } from '../../AlertsAndNotification/utils/alertScrollPriority';

export type SlideoutFeaturesContainerSectionProps = {
  featuresRef: React.Ref<HTMLDivElement>;
  featuresContainerRef: React.Ref<FeaturesContainerRef>;
  issueId?: string;
  momentName?: string;
  defaultSurfaces: string[];
  targetFeatureId: string | null;
  targetProductId: string | null;
  forceExpanded: boolean;
  printMode?: boolean;
  onCommentIconClick: () => void;
  onDataRefresh: (patchResponse?: unknown) => void;
  onNotificationRefresh: (patchResponse?: unknown) => void;
  isOpen?: boolean;
  /** Phase order ([] for non-phased) — forwarded to FeaturesContainer's scroll-priority check. */
  phases?: PhaseOrderEntry[];
};

/**
 * Features list wiring (FeaturesContainer ref + refresh callbacks) — Part 2B-3.
 */
export function SlideoutFeaturesContainerSection({
  featuresRef,
  featuresContainerRef,
  issueId,
  momentName,
  defaultSurfaces,
  targetFeatureId,
  targetProductId,
  forceExpanded,
  printMode,
  onCommentIconClick,
  onDataRefresh,
  onNotificationRefresh,
  isOpen,
  phases
}: SlideoutFeaturesContainerSectionProps) {
  return (
    <div ref={featuresRef}>
      <FeaturesContainer
        ref={featuresContainerRef}
        issueId={issueId}
        momentName={momentName}
        defaultSurfaces={defaultSurfaces}
        targetFeatureId={targetFeatureId}
        targetProductId={targetProductId}
        forceExpanded={forceExpanded}
        printMode={printMode}
        onCommentIconClick={onCommentIconClick}
        onDataRefresh={onDataRefresh}
        onNotificationRefresh={onNotificationRefresh}
        isOpen={isOpen}
        phases={phases}
      />
    </div>
  );
}

export type SlideoutLegacyFeaturesTabProps = {
  features?: string[];
};

/** Legacy simple Features tab (activeSection === 'features'). */
export function SlideoutLegacyFeaturesTab({
  features
}: SlideoutLegacyFeaturesTabProps) {
  return <FeaturesSection features={features} />;
}
